var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import { Project } from '@/models/Project';
import AQuillEditor, { AQuillEditorActionsEnum } from '@/components/AQuillEditor/AQuillEditor.vue';
let Notes = class Notes extends Vue {
    constructor() {
        // File structure for Typescript files in your Vue project
        // https://tutorials.atabix.com/frontend/typscript_file_structure/
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.evaluation = '';
        this.AQuillEditorActionsEnum = AQuillEditorActionsEnum;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    mounted() {
        this.isLoading = true;
        this.prefillExistingEvaluation();
        this.isLoading = false;
    }
    // #endregion
    // #region Class methods
    prefillExistingEvaluation() {
        this.project && this.project.evaluation ? (this.evaluation = this.project.evaluation) : (this.evaluation = '');
    }
    // #endregion
    // #region Async methods
    async save() {
        try {
            const project = await this.project.update({
                evaluation: this.evaluation,
            });
            this.$store.dispatch('openDialog', this.dialogOptions);
            this.$emit('update:project', project);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    // #endregion
    // #region Getters & Setters
    get dialogOptions() {
        return {
            title: this.$tc('dialogOptions.confirmation'),
            text: this.$tc('Evaluation successfully saved'),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$tc('dialogOptions.button.ok'),
                },
            },
        };
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Project !== "undefined" && Project) === "function" ? _a : Object)
], Notes.prototype, "project", void 0);
Notes = __decorate([
    Component({
        components: {
            AQuillEditor,
        },
    })
], Notes);
export default Notes;
